module.exports = __webpack_public_path__ + "img/loghi-cantine-divinea-desktop.6fc5f872.jpg";